import { EntityModelGrantAndFunctionDto } from "openapi";

export interface TProps {
  operation: string;
  component: string;
  func?: string;
  userGrants: EntityModelGrantAndFunctionDto[];
}

export const checkOperationPermission = ({
  operation,
  component,
  func,
  userGrants,
}: TProps) =>
  userGrants.some((userGrant) => {
    const componentCheck =
      userGrant.function.description.toLowerCase() === component.toLowerCase();

    const codeGrantCheck = userGrant.grant === operation;

    const funcCheck = func ? userGrant.function.codeFunction === func : true;

    return componentCheck && codeGrantCheck && funcCheck;
  });
